<script>
export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  props: {
    plan: {
      default: null,
    }
  }
};
</script>

<template>
  <div class="card" v-if="plan">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center">
        <div v-if="plan.name">
          <p class="mb-1 text-muted">{{ plan.name }}</p>
          <h2 class="mb-1 text-default">{{ plan.description }}</h2>
          <h5 class="mb-0 text-dark">{{ plan.value | currency }}</h5>
        </div>
      </div>
      <div v-if="$slots.footer" class="mt-3 pt-3 border-top">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>